<template>
  <home-base-rail :label="label" :variant="variant">
    <component
      :is="cardComponent"
      v-for="project in items"
      :key="project.id"
      :project="project"
      :label="cardLabel"
      @favorite-changed="$emit('favorite-changed', $event)"
    />
  </home-base-rail>
</template>

<script>
import HomeBaseRail from "./HomeBaseRail.vue";
import HomeProjectCard from "@/components/home/cards/HomeProjectCard.vue";
import HomeEditorialProjectCard from "@/components/home/cards/HomeEditorialProjectCard.vue";
import HomeCompletedProjectCard from "@/components/home/cards/HomeCompletedProjectCard.vue";

export default {
  name: "HomeProjectRail",
  components: {
    HomeBaseRail,
    HomeProjectCard,
    HomeEditorialProjectCard,
    HomeCompletedProjectCard,
  },
  props: {
    items: { type: Array, default: () => [] },
    label: { type: String, default: "obras" },
    variant: { type: String, default: "projects" },
    card: { type: String, default: "project" },
    cardLabel: { type: String, default: "" },
  },
  computed: {
    cardComponent() {
      if (this.card === "editorial") return "HomeEditorialProjectCard";
      if (this.card === "completed") return "HomeCompletedProjectCard";
      return "HomeProjectCard";
    },
  },
};
</script>
